<template>
    <div class="container">

        <div class="card">
            <Toolbar class="p-mb-4">
                <template #start>
                    <Button label="Nuovo" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
                    <!-- <Button label="Cancella" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected"
                        :disabled="!selectedPuns || !selectedPuns.length" /> -->
                </template>

                <template #end>
                    <Button label="Esporta" icon="pi pi-download" class="p-button-secondary ml-2"
                        @click="exportCSV($event)" />
                </template>
            </Toolbar>

            <DataTable ref="dt" :value="puns" dataKey="id" :loading="loading"
                :paginator="true" :rows="10" :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 25]" currentPageReportTemplate="{first} a {last} di {totalRecords} records"
                responsiveLayout="scroll">
                <template #header>
                    <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                        </span>
                    </div>
                </template>

                <Column field="mese" header="MESE" :sortable="true"></Column>
                <Column field="f1" header="F1" :sortable="true"></Column>
                <Column field="f2" header="F2" :sortable="true"></Column>
                <Column field="f3" header="F3" :sortable="true"></Column>
                <Column field="op" header="OP" :sortable="true"></Column>
                <Column field="p" header="P" :sortable="true"></Column>
                <!-- <Column :exportable="false">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                            @click="editPun(slotProps.data)" />
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning"
                            @click="confirmDeletePun(slotProps.data)" />
                    </template>
                </Column> -->
            </DataTable>
        </div>

        <Dialog v-model:visible="punDialog" :style="{ width: '450px' }" :header="titleDialog" :modal="true"
            class="p-fluid">
            <div class="grid">
                <div class="col-4">
                    <div class="p-field">
                        <label for="f1">F1</label>
                        <InputText id="f1" v-model.trim="pun.f1" required="true" autofocus
                            :class="{ 'p-invalid': submitted }" :value="pun.f1" />
                        <small class="p-error" v-if="submitted">F1 è richiesto</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="p-field">
                        <label for="f2">F2</label>
                        <InputText id="f2" v-model.trim="pun.f2" required="true" autofocus
                            :class="{ 'p-invalid': submitted }" :value="pun.f2" />
                        <small class="p-error" v-if="submitted">F2 è richiesto</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="p-field">
                        <label for="f3">F3</label>
                        <InputText id="f3" v-model.trim="pun.f3" required="true" autofocus
                            :class="{ 'p-invalid': submitted }" :value="pun.f3" />
                        <small class="p-error" v-if="submitted">F3 è richiesto</small>
                    </div>
                </div>
                <div class="col-6">
                    <div class="p-field">
                        <label for="op">OP</label>
                        <InputText id="op" v-model.trim="pun.op" required="true" autofocus
                            :class="{ 'p-invalid': submitted }" :value="pun.op" />
                        <small class="p-error" v-if="submitted">OP è richiesto</small>
                    </div>
                </div>
                <div class="col-6">
                    <div class="p-field">
                        <label for="p">P</label>
                        <InputText id="p" v-model.trim="pun.p" required="true" autofocus
                            :class="{ 'p-invalid': submitted }" :value="pun.p" />
                        <small class="p-error" v-if="submitted">P è richiesto</small>
                    </div>
                </div>
            </div>

            <div class="p-field">
                <label for="mese" class="p-mb-3">Mese</label>
                <Calendar id="mese" @date-select="selectDate" v-model="pun.mese" view="month" dateFormat="yy-mm-dd"
                    :yearNavigator="true" yearRange="2000:2090" value="" />
            </div>

            <template #footer>
                <Button label="Annulla" icon="pi pi-times" class="p-ml-auto p-button-danger" @click="hideDialog" />
                <Button label="Salva" icon="pi pi-check" class="p-button-success mr-2" @click="savePun" />
            </template>
        </Dialog>

        <Dialog v-model:visible="deletePunDialog" :style="{ width: '450px' }" header="Conferma eliminazione"
            :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="pun">Eliminare il pun di {{ moment(pun.mese).format('MMMM YYYY') }} ?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-danger" @click="deletePunDialog = false" />
                <Button label="Si" icon="pi pi-check" class="p-button-success" @click="deletePun" />
            </template>
        </Dialog>

        <Dialog v-model:visible="deletePunsDialog" :style="{ width: '450px' }" header="Conferma eliminazione"
            :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span v-if="pun">Confermi la cancellazione di {{ selectedPuns.length }} elementi?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deletePunsDialog = false" />
                <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedPuns" />
            </template>
        </Dialog>
    </div>
</template>

<script>

import moment from 'moment'
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import { FilterMatchMode } from 'primevue/api';


export default {
    components: {

    },

    setup() {
        onMounted(() => {
            getData();
        })

        // const toast = useToast();
        moment.locale('it');
        const dt = ref();
        const puns = ref([]);
        const punDialog = ref(false);
        const loading = ref(false);
        const deletePunDialog = ref(false);
        const deletePunsDialog = ref(false);
        const pun = ref({});
        const titleDialog = ref()
        const selectedPuns = ref();
        const filters = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const submitted = ref(false);
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)


        const getData = () => {
            loading.value = true;
            service.getAllPun().then((res) => {
                puns.value = res.items
            }).finally(() => {
                loading.value = false;
            })
        }

        const selectDate = (value) => {
            pun.value.mese = moment(value).format('YYYY-MM-DD')
        }

        const openNew = () => {
            titleDialog.value = 'Crea'
            pun.value = {};
            submitted.value = false;
            punDialog.value = true;
        };
        const hideDialog = () => {
            punDialog.value = false;
            submitted.value = false;
        };
        const savePun = () => {
            submitted.value = false;

            if (pun.value.id) {
                service.editPun(pun.value).then(() => {
                    getData()
                })
            } else {
                service.createPun(pun.value).then(() => {
                    getData()
                })
            }

            punDialog.value = false;
            pun.value = {};

        };
        const editPun = (prod) => {
            titleDialog.value = 'Modifica'
            pun.value = { ...prod };
            punDialog.value = true;
        };
        const confirmDeletePun = (prod) => {
            pun.value = prod;
            deletePunDialog.value = true;
        };
        const deletePun = () => {
            // puns.value = puns.value.filter(val => val.id !== product.value.id);
            service.deletePun(pun.value).then(() => {
                getData()
            }).finally(() => {
                deletePunDialog.value = false;
                pun.value = {};
            });

        };

        const confirmDeleteSelected = () => {
            deletePunsDialog.value = true;
        };
        const deleteSelectedPuns = () => {
            // puns.value = puns.value.filter(val => !selectedProducts.value.includes(val));
            service.deletePuns(selectedPuns.value).then(() => {
                getData()
            }).finally(() => {
                deletePunsDialog.value = false;
                selectedPuns.value = null;
            });
        };

        const exportCSV = () => {
            dt.value.exportCSV();
        };

        return {
            selectDate, dt, pun, puns, punDialog, deletePunDialog, deletePunsDialog, moment,
            selectedPuns, filters, submitted, openNew, hideDialog, savePun, editPun, titleDialog,
            confirmDeletePun, deletePun, exportCSV, confirmDeleteSelected, deleteSelectedPuns, loading
        }
    }
}
</script>

<style lang="css" scoped>
.product-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    align-items: center;
}

@media screen and (max-width: 960px) {
    .p-toolbar {
        flex-wrap: wrap;
    }

    .p-button {
        margin-bottom: 0.25rem;
    }

}
</style>
